// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1___3ce890f19957100357e","cls2":"SocialActionsMenu-cls2__dbbc6a3f8470af37a640 SocialActionsMenu-cls1___3ce890f19957100357e"};